import { Modal } from '@components/Modal'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { useState } from 'react'
import { ChangePasswordForm } from './ChangePasswordForm'
import { RequestCodeForm } from './RequestCodeForm'

type ForgotPasswordProps = {
  handleRequestClose: () => void
  initialEmail?: string
  status: 'closed' | 'request' | 'verify'
  handleChangeStatus: (status: 'closed' | 'request' | 'verify') => void
  copyStyle?: 'forgotten' | 'reset-required'
}

export function ForgotPasswordModal({
  handleRequestClose,
  handleChangeStatus,
  initialEmail = '',
  status,
  copyStyle = 'forgotten',
}: ForgotPasswordProps) {
  const [email, setEmail] = useState<string>(initialEmail)
  const router = useRouter()
  const {
    t,
    i18n: { language },
  } = useTranslation(['account'])

  return (
    <Modal
      title={copyStyle === 'forgotten' ? t('requestPasswordResetTitle') : t('resetPasswordTitle')}
      open={status !== 'closed'}
      onOpenChange={(open) => {
        if (!open) {
          handleRequestClose()
        }
      }}
    >
      {status === 'request' ? (
        <RequestCodeForm
          onSuccess={(email) => {
            setEmail(email)
            handleChangeStatus('verify')
          }}
          initialEmail={initialEmail}
        />
      ) : (
        <ChangePasswordForm
          explanation={copyStyle === 'reset-required' ? t('migrationDescription') : undefined}
          onSuccess={() => {
            router.push(`/${language}${t('membership.overview.url', { ns: 'navigation' })}`)
          }}
          email={email}
        />
      )}
    </Modal>
  )
}
